module.exports = __webpack_public_path__ + "img/mask.a2bd5ed7.svg";